import { api } from '@chew/common/services/network/api';
import { GetHomePageResponse } from '@chew/common/domains';

export const getHomePage = () => api.get<{ data: GetHomePageResponse }>(`/page/index`).then(({ data }) => data);
